<div class="site-layout">
  <router-outlet></router-outlet>
</div>